<div
	mat-dialog-title
	[align]="'end'">
	<button
		mat-icon-button
		mat-dialog-close>
		<mat-icon>close</mat-icon>
	</button>
</div>
<div mat-dialog-content>
	<pdf-viewer
		[src]="data"
		[render-text]="true"
		[original-size]="true"
		[fit-to-page]="true"
		[autoresize]="true"
		[external-link-target]="'blank'"
		[show-borders]="true"
		[zoom-scale]="'page-width'"
		class="w-full h-full" />
</div>
